import React from "react";


import FORCode from "./FORCode";
import HERDCCode from "./HERDCCode";
import SEOCode from "./SEOCode";
import TOACode from "./TOACode";

const defaultComponent = () => <div>Unknown Code Type</div>;
const Components = {
	FOR: FORCode,
	HERDC: HERDCCode,
	SEO: SEOCode,
	TOA: TOACode,
};

export const getComponentForCodeType = codeType => Components?.[codeType] || defaultComponent;
